import React, { useContext } from 'react';

import { GlobalContext } from '../../contexts/global.context';

import './biomassText.styles.scss';

export default function BiomassText() {
  const { selectedSubTab } = useContext(GlobalContext);

  let treespecies = '';
  if (selectedSubTab === 'Beech Leaf Disease') {
    treespecies = 'American Beech'
  } else if (selectedSubTab === 'Hemlock Woolly Adelgid') {
    treespecies = 'Eastern Hemlock'
  } else if (selectedSubTab === 'Heterobasidion Root Disease') {
    treespecies = 'Eastern Red Cedar, Loblolly Pine, Red Pine, Jack Pine, Eastern White Pine, Slash Pine, Shortleaf Pine, Longleaf Pine, Virginia Pine, and Pitch Pine'
  } else if (selectedSubTab === 'Pine Wilt Disease') {
    treespecies = 'Scots Pine, Austrian Pine, Jack Pine, Mugo Pine, and Ponderosa Pine'
  } else if (selectedSubTab === 'Southern Pine Beetle') {
    treespecies = 'Loblolly Pine, Shortleaf Pine, Pitch Pine, Pond Pine, and Virginia Pine'
  } else if (selectedSubTab === 'White Pine Needle Damage') {
    treespecies = 'Eastern White Pine'
  } else if (selectedSubTab === 'White Oak Freeze Damage') {
    treespecies = 'White Oak (Quercus alba)'
  } else if (selectedSubTab === 'Red Oak Freeze Damage') {
    treespecies = 'Northern Red Oak (Quercus rubra)'
  }

  return (
    <div className='biomass-text-container'>
      {treespecies ? (
        <p className='biomass-text'>Tree species include: {treespecies}</p>
      ) : ''}
    </div>
  );
}
